import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { DetailReportResponse } from 'src/app/_models/pcmws/reports/detailReportResponse';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { RouteState } from 'src/app/_models/state/routeState';
import { StopState } from 'src/app/_models/state/stopState';
import { DetailReportReportLineView } from '../../_models/view/detailReportView';

@Component({
  selector: 'app-detail-report',
  templateUrl: './detail-report.component.html',
  styles: [],
})
export class DetailReportComponent implements OnInit {
  @Input() route: RouteState;
  @Input() displayCurrency: CurrencyState;
  @Input() printView: boolean;
  @Input() distanceUnits: number;
  @Input() precision: number;
  detailReportCopy: DetailReportResponse;
  detailReportReportLineView: DetailReportReportLineView[] = [];
  hasTolls = false;
  hasEta = false;
  stops: StopState[];
  counter = 0;
  ngOnInit() {
    this.detailReportCopy = cloneDeep(this.route?.detailReport);
    this.detailReportReportLineView = this.detailReportCopy?.ReportLegs.map(
      (directionReportLeg) => directionReportLeg?.ReportLines
    )
      .map((reportLines) => reportLines)
      .reduce(
        (acc, res) => acc.concat(res ? res : []),
        [] as DetailReportReportLineView[]
      );
    this.addStopAddress(this.detailReportReportLineView);
    this.hasTolls =
      this.route?.detailReport?.ReportLegs.findIndex(
        (reportLeg) =>
          reportLeg.ReportLines.findIndex(
            (reportLine) => reportLine.TollPlazaAbbr || reportLine.LToll
          ) >= 0
      ) >= 0;

    this.hasEta =
      this.route?.detailReport?.ReportLegs.findIndex(
        (reportLeg) =>
          reportLeg.ReportLines.findIndex(
            (reportLine) =>
              reportLine.EtaEtd !== null && reportLine.EtaEtd !== ''
          ) >= 0
      ) >= 0;
  }
  addStopAddress(detailReportReportLineView: DetailReportReportLineView[]) {
    return detailReportReportLineView?.filter((rl) => {
      if (rl.Stop !== null) {
        rl.routeAddress = this.route.stopsState[this.counter];
        this.counter++;
      }
      return rl;
    });
  }
}
